export const weapons = {

    battle_axes: "бойові сокири",
    battle_axes_details: "",

    hand_axes: "ручні сокири",
    hand_axes_details: "",

    light_hammers: "легкі молоти",
    light_hammers_details: "",

    battle_hammers: "бойові молоти",
    battle_hammers_details: "",

    long_swords: "довгі мечі",
    long_swords_details: "",

    short_swords: "короткі мечі",
    short_swords_details: "",

    long_bows: "довгі луки",
    long_bows_details: "",

    short_bows: "короткі луки",
    short_bows_details: "",

    rapires: "рапіри",
    rapires_details: "",

    hand_arbalets: "ручні арбалети",
    hand_arbalets_details: "",

    simple: "проста",
    simple_details: "",

    military: "військова",
    military_details: "",

    improvised: "імпровізована",
    improvised_details: "",

    loading:"довга перезарядка",
    loading_details:"Через довгу перезарядку цієї зброї ви можете вистрілити з неї лише один раз за хід, незалежно від кількості доступних атак.",
                    
    light:"легка",
    light_details:"Маленька та зручна, і ідеально підходить для битви двома зброями.",

    heavy:"важка",
    heavy_details:"Занадто важка для істот Маленького розміру. Вони роблять кидки атаки важкою зброєю із перешкодою.",

    daggers: "кинджали",
    daggers_details: "",

    darts: "дротики",
    darts_details: "",

    slings: "пращі",
    slings_details: "",

    quarterstaffs: "посохи",
    quarterstaffs_details: "",

    light_arbalets: "легкі арбалети",
    light_arbalets_details: "",

    maces: "булави",
    maces_details: "",

    clubs: "дубинки",
    clubs_details: "",

    spears: "списи",
    spears_details: "",

    javelins: "метальні списи",
    javelins_details: "",

    sickles: "серпи",
    sickles_details: "",

    scimitars: "ятагани",
    scimitars_details: "",

    // ----------------------------

    quarterstaff:"бойовий посох",
    quarterstaff_details:"Довга жердина з легких сплавів металу, сталі або дерева.",

    mace:"булава",
    mace_details:"Металевий кийок з шипами або лезами, призначений для пробивання броні або збивання солдата з коня.",

    club:"дубинка",
    club_details:"Дерев'яна зброя середньої довжини, потовщена на кінці.",

    dagger:"кинджал",
    dagger_details:"Короткий та гострий клинок.",

    spear:"спис",
    spear_details:"Зброя, що складається з дерев'яного держака та наконечника гострої форми з металу.",

    light_hammer:"легкий молот",
    light_details:"Засіб для будівництва та кування, перероблений у зброю.",
    
    javelin:"метальний спис",
    javelin_details:"Зброя, що складається з легкого дерев'яного держака та наконечника гострої форми з металу.",

    greatclub:"палиця",
    greatclub_details:"Важкий шмат дерева",

    handaxe:"ручна сокира",
    handaxe_details:"Ручний інструмент, що рубає, з металевим лезом, що жорстко закріплений на дерев'яній рукояті. Рисою даної сокири є те, що вона особливим чином збалансована для зручності метання.",

    sickle:"серп",
    sickle_details:"Зброя, що складається з рукояті та вигнутого леза середнього розміру.",

    light_crossbow:"легкий арбалет",
    light_crossbow_details:"Легкі арбалети використовуються двома руками і мають більшу дальність.",// добавить про боеприпасьі

    dart:"дротик",
    dart_details:"Снаряд для духової трубки, яким можна кидати і без неї.",

    shortbow:"короткий лук",
    shortbow_details:"Короткі луки висотою близько трьох футів і вимагають певної сили та навички для ефективного використання.",// добавить про боеприпасьі

    sling:"праща",
    sling_details:"Проста метальна зброя, виготовлена з мішечка і шнура. Використовується для того, щоб метати маленький круглий снаряд з великою силою. Зазвичай використовуються снаряди з твердого металу, які називають «кулями», але великою перевагою пращі є те, що їй також можна запускати будь-які дрібні об'єкти, такі як каміння або монети.",

    halberd:"алебарда",
    halberd_details:"Зброя, що складається з дерев'яного держака та металевого леза на його кінці. Комбінуючи досяжність держака з лезом сокири, алебарда дозволяє вмілому бійцю використовувати безліч бойових прийомів.",

    war_pick:"бойова кірка",
    war_pick_details:"Маленький гострий шип з рукояттю, що традиційно використовується для руйнування льоду або каменю. Кірку легко сховати і вона ефективна у ближньому бою.",

    warhammer:"бойовий молот",
    warhammer_details:"Зброя з довгою рукояттю та маленькою важкою головкою, яку можна використовувати швидко та спритно.",

    battleaxe:"бойова сокира",
    battleaxe_details:"Зброя з рукояттю середньої довжини та односторонньою металевою лопаттю, якою можна прорубати зброю.",

    glaive:"глефа",
    glaive_details:"Зброя, що складається з дерев'яного держака та металевого леза на її кінці. Вигнута верхівка глефи дозволяє завдавати додаткових втрат.",

    greatsword:"дворучний меч",
    greatsword_details:"Потужна зброя, яка потребує величезної сили та вміння для ефективного використання.",

    lance:"довгий спис",
    lance_details:'Зброя, що складається з довгого деревʼяного держака і наконечника гострої форми з металу.\n\n' +
    'Особливі властивості:\n' +
    '• Перешкода на атаки по цілі в межах 5 футів.\n' +
    '• Перебуваючи верхи, можна використовувати однією рукою.\n',

    longsword:"довгий меч",
    longsword_details:"Меч, який за вагою та довжиною рукояті може використовуватися як однією, так і двома руками.",

    whip:"батіг",
    whip_details:"Довгий батіг з металевими лезами у кінця.",

    shortsword:"короткий меч",
    shortsword_details:"Швидка та універсальна зброя. Невелика вага, низька ціна. Дозволяє власнику також носити щит – важливий чинник для бійців, яким недоступна міцна броня.",

    maul:"молот",
    maul_details:"Молот із важкою головкою для пробивання обладунків.",

    morningstar:"моргенштерн",
    morningstar_details:"кисть з ланцюгом і металевою шипованою кулею на кінці.",

    pike:"піка",
    pike_details:"Зброя, що складається з особливо довгого дерев'яного держака та наконечника гострої форми з металу.",

    rapier:"рапіра",
    rapier_details:"Шпага зі штикоподібним клинком",

    greataxe:"велика сокира",
    greataxe_details:"Зброя з довгою рукояттю, великим лезом і гаком на обусі, що дозволяє, наприклад, стягувати вершника з коня.",

    scimitar:"ятаган",
    scimitar_details:"Вигнута шабля.",

    trident:"тризуб",
    trident_details:"Зброя, що складається з довгого дерев'яного держака і наконечника з трьома зубцями.",

    flail:"цепи",
    flail_details:"Зброя, що складається з трьох гнучко зчленованих твердих палиць.",

    hand_crossbow:"ручний арбалет",
    hand_crossbow_details:"Ручні арбалети малі і можуть використовуватися однією рукою, але мають відносно низьку дальність.",

    heavy_crossbow:"важкий арбалет",
    heavy_crossbow_details:"Важкі арбалети використовуються двома руками і мають найбільшу дальність.",

    longbow:"довгий лук",
    longbow_details:"Довгі луки висотою близько пʼяти футів і вимагають певної сили та навички для ефективного використання. Їх не так легко носити з собою",

    blowgun:"духова трубка",
    blowgun_details:"Трубка для стрільби дротиками на більшу відстань.",

    net:"сітка",
    net_details:'Велика і міцна сітка, що дозволяє знешкодити ворога.\n\n' +
    'Особливі властивості:\n' +
    '• Істоти Великого та меншого розмірів, в яку поцілила атака сіткою, стають обплутаними, поки не вивільняться.\n' +
    '• Сітка не впливає на безформних істот і тих, чий розмір Величезний або ще більше.\n' +
    '• Істота може Основною дією здійснити перевірку Сили зі Сл 10, щоб звільнитися самому або звільнити іншу істоту, яка знаходиться в межах її досяжності. Заподіяння сітці 5 одиниць рубаного пошкодження (Броня 10) теж звільняє істоту, не завдаючи їй шкоди, закінчуючи ефект і знищуючи сітку.\n' +
    '• Якщо ви Основною,Бонусною дією або реакцією атакуєте сіткою, ви можете зробити лише одну атаку, незалежно від кількості доступних атак.\n',

    unarmed: "Кулак",
    unarmed_details: "При здійсненні ближньої атаки зброєю можна використовувати беззбройний удар: штовхнути, ударити кулаком, головою або інший аналогічний удар (ніщо з цього не вважається зброєю).",
}